import { useEffect } from "react";
import { enableAngleBracketInputFilter } from "../utils/angleBracketInputFilter";

/**
 * Blocks `<` and `>` characters in all text inputs and textareas app-wide.
 * Mount once near the application root.
 */
export const useInputValidation = () => {
  useEffect(() => enableAngleBracketInputFilter(), []);
};
